import {UserInfo} from '@/store/auth-slice';
import MixedStorageUtil from './mixed-storage-util';
import StorageUtil from './storage-util';

let cacheUserInfoSequence = 1;
let cachedUserInfo: UserInfo | undefined;
let setSliceUserInfoCallback: ((user?: UserInfo) => void) | undefined;

const RETURN_URL_KEY = 'return-url';
const USER_TOKEN_KEY = `user-token`;
const APP_CODE = 'c3c07192c2c189cb301d645e3d26f5d8';

export default {
    setSliceUserInfo: (user?: UserInfo) => {
        setSliceUserInfoCallback?.(user);
    },

    setCacheUserInfo: (user?: UserInfo) => {
        cachedUserInfo = user;
        if (cachedUserInfo) {
            cachedUserInfo.sequence = cacheUserInfoSequence;
        }
        cacheUserInfoSequence++;
    },

    getCacheUserInfo: () => {
        return cachedUserInfo;
    },

    setSliceUserInfoCallback: (callback?: (user?: UserInfo) => void) => {
        setSliceUserInfoCallback = callback;
    },

    setReturnUrl: (url: string) => {
        StorageUtil.setLocalString(RETURN_URL_KEY, url);
    },

    getReturnUrl: () => {
        return StorageUtil.getLocalString(RETURN_URL_KEY);
    },

    getAppCode: () => {
        return APP_CODE;
    },

    setStoreUserToken: (tokens?: object) => {
        if (tokens) {
            MixedStorageUtil.set(USER_TOKEN_KEY, JSON.stringify(tokens));
        } else {
            MixedStorageUtil.set(USER_TOKEN_KEY, '');
        }
    },

    getStoreUserToken: () => {
        const tokens = MixedStorageUtil.get(USER_TOKEN_KEY);
        if (tokens) {
            return JSON.parse(tokens);
        }
        return undefined;
    },
};
